module.exports = __webpack_public_path__ + "img/19200.97514ee6.jpg";